export interface IContent {
    localizationPath: string;
    headerKeys: string[];
    textKeys: string[];
    optionKeys?: string[];
    image: string;
    alt: string;
    logo: string;
}

export const getContent = (isKscMode: boolean) => (isKscMode ? kscContent : nextContent);

const kscContent: IContent[] = [
    {
        localizationPath: 'Landing.Ksc_Orchestration',
        headerKeys: ['Header'],
        textKeys: ['Text1', 'Text2'],
        image: 'plugins/landing/web/images/ksc_orchestration.webp',
        alt: 'Orchestration of security image',
        logo: 'plugins/landing/web/images/k_Security_Center_Cloud_Console_black_icon.png',
    },
    {
        localizationPath: 'Landing.Ksc_PluginPower',
        headerKeys: ['Header'],
        textKeys: ['Text1', 'Text2'],
        image: 'plugins/landing/web/images/ksc_plugin_power.webp',
        alt: 'Plug-in power image',
        logo: 'plugins/landing/web/images/k_Security_Center_Cloud_Console_black_icon.png',
    },
    {
        localizationPath: 'Landing.Ksc_Migration',
        headerKeys: ['Header'],
        textKeys: ['Text1'],
        image: 'plugins/landing/web/images/ksc_migration.webp',
        alt: 'Migration image',
        logo: 'plugins/landing/web/images/k_Security_Center_Cloud_Console_black_icon.png',
    },
];

const nextContent: IContent[] = [
    {
        localizationPath: 'Landing.Next_Edr_Foundations',
        headerKeys: ['Header', 'SubHeader'],
        textKeys: ['Text1'],
        optionKeys: ['Option1', 'Option2', 'Option3'],
        image: 'plugins/landing/web/images/next_edr_foundations.webp',
        alt: 'Orchestration of security image',
        logo: 'plugins/landing/web/images/next_edr_foundations_icon.png',
    },
    {
        localizationPath: 'Landing.Next_Edr_Optimum',
        headerKeys: ['Header', 'SubHeader'],
        textKeys: ['Text1'],
        optionKeys: ['Option1', 'Option2', 'Option3'],
        image: 'plugins/landing/web/images/next_edr_optimum.webp',
        alt: 'Orchestration of security image',
        logo: 'plugins/landing/web/images/next_edr_optimum_icon.png',
    },
    {
        localizationPath: 'Landing.Next_Xdr_Optimum',
        headerKeys: ['Header', 'SubHeader'],
        textKeys: ['Text1'],
        optionKeys: ['Option1', 'Option2', 'Option3', 'Option4'],
        image: 'plugins/landing/web/images/next_xdr_optimum.webp',
        alt: 'Orchestration of security image',
        logo: 'plugins/landing/web/images/next_edr_optimum_icon.png',
    },
];
